import i18n from 'i18next';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import useStyles from './MissionConfigurationUpload.styles';
import { inputToFormData } from '../../../common/utils/fileMethods';
import { Button, UploadButton } from '../../../common/components/buttons';

const MissionConfigurationUpload = ({ onUploadClick }) => {
  const classes = useStyles();

  const handleUploadClick = useCallback(
    (callback) => {
      onUploadClick(inputToFormData(callback, 'file'));
    },
    [onUploadClick]
  );

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <div className={classes.text}>{i18n.t('mission.message.uploadPrompt')}</div>
        <UploadButton onClick={handleUploadClick} type=".kml">
          <Button component="span" primary>
            {i18n.t('mission.button.uploadNewMission')}
          </Button>
        </UploadButton>
      </div>
    </div>
  );
};

MissionConfigurationUpload.propTypes = {
  onUploadClick: PropTypes.func,
};

MissionConfigurationUpload.defaultProps = {
  onUploadClick: undefined,
};

export default MissionConfigurationUpload;
